<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-card title="Crear nuevos usuarios">
        <b-card-body style="display: flex">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-row class="form-group">
              <b-col md="10">
                <label>Nombres</label>
                <input v-model="name" class="form-control" placeholder="Nombres">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <label>Telefono</label>
                <input v-model="phone" class="form-control" placeholder="Telefono">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <label>Role</label>
                <select v-model="role" class="form-control">
                  <option value="client">CLIENTE</option>
                  <option value="agent">AGENTE</option>
                  <option value="administrator">ADMINISTRADOR</option>
                </select>
              </b-col>
            </b-row>


          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-row class="form-group">
              <b-col md="10">
                <label>Email</label>
                <input v-model="email" class="form-control" placeholder="Email">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <label>Identificación</label>
                <input v-model="identification" class="form-control" placeholder="Identificacion">
              </b-col>
            </b-row>

            <b-row class="form-group">
              <b-col md="10">
                <label for="">Contraseña</label>
                <input v-model="password" class="form-control" placeholder="Contraseña">
              </b-col>
            </b-row>
          </div>
        </b-card-body>
        <b-row>
          <b-col class="text-right">
            <b-button variant="primary" @click="createUser">CREAR NUEVO USUARIO</b-button>
          </b-col>
        </b-row>
      </b-card>
      <hr>
      <b-card title="Importar usuarios">
        <b-card-body style="display: flex">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-row class="form-group">
              <b-col lg="12" md="12" sm="12">
                <input v-model="user_token" class="form-control" placeholder="Ingresar token">
                <b-button variant="primary" class="mt-2" @click="findUser">BUSCAR USUARIO</b-button>
              </b-col>
            </b-row>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label>Detalles del usuario</label>
            <ul v-if="user_found && user_found.user">
              <li>Nombre: {{user_found.user.name}}</li>
              <li>Email: {{user_found.user.email}}</li>
              <li>Identificacion: {{user_found.user.identification}}</li>
              <li>Pais: {{user_found.user.country}}</li>
              <li>Cantidad transacciones: <span v-if="user_found.transaction">{{user_found.transaction.total_transactions}}</span></li>
              <li>Monto rastreado: <span v-if="user_found.transaction">{{user_found.transaction.total_amount | number}}</span></li>
            </ul>
          </div>
        </b-card-body>
        <b-card-footer>
          <div class="d-flex justify-content-end">
            <b-button variant="primary" class="text-right" @click="importUser">IMPORTAR USUARIO</b-button>
          </div>
        </b-card-footer>
      </b-card>
    </b-container>
    <b-modal id="modal_send_email" hide-footer>
      <h4>El usuario fue creado correctamente.</h4>
      <h5>Desea enviar email de bienvenida?</h5>
      <select name="" id="" v-model="company" class="form-control">
        <option value="">Seleccione una opcion</option>
        <option value="united">Bank United</option>
        <option value="amex">Bank America</option>
      </select>
      <input type="text" class="form-control mt-2" placeholder="Ingrese el numero de cuenta" v-model="account">
      <button class="btn btn-dark btn-block mt-2" @click="sendEmail">Si, Enviar email</button>
      <button class="btn btn-danger btn-block mt-2" @click="closeModal">No, No enviar email</button>
    </b-modal>
  </div>
</template>

<script>
import {post} from "@/util/axiosRequest";
import axios from "axios";

export default {
  name: "Create",
  data: () => ({
    name: null,
    email: null,
    phone: null,
    identification: null,
    role: 'client',
    password: null,
    company: "",
    account: "",
    user_token: "",
    user_found: null,
  }),
  methods: {
    createUser() {
      if (this.name !== null && this.email !== null && this.phone !== null && this.identification !== null && this.role !== null && this.password !== null) {
        post("users/create", {
          name: this.name.toUpperCase().trim(),
          email: this.email.trim(),
          phone: this.phone.trim(),
          identification: this.identification.trim(),
          type: this.role,
          password: this.password.trim()
        }, true).then(({data}) => {
          if(data == 200){
            if(this.role === 'client'){
              this.$bvModal.show('modal_send_email')
            }else{
              this.showMessage('Usuario creado correctamente', 'success')
              this.clear()
            }
          }else{
            this.showMessage('El email ya se encuentra registrado', 'error')
          }
        })
      } else {
        this.showMessage('Todos los campos son requeridos', 'error')
      }
    },
    clear() {
      this.name = null
      this.email = null
      this.phone = null
      this.identification = null
      this.role = null
      this.password = null
      this.company = ""
      this.account = ""
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
    async sendEmail(){
      if(this.company !== "" && this.company !== null && this.account !== "" && this.account !== null){
        this.$swal({
          html: 'El email se esta enviando por favor espere',
          timer: 3000,
          showCloseButton: true,
          show: false,
          confirmButtonColor: '#191c4d',
          cancelButtonColor: '#191c4d',
        });
        await post("users/send-email", {
          company: this.company,
          email: this.email,
          name: this.name.toUpperCase(),
          account: this. account
        }, true)
        this.showMessage("Email enviado correctamente", "success")
        this.closeModal()
      }else{
        this.showMessage('Toda la informacion es requerida', 'error')
      }
    },
    closeModal(){
      this.clear()
      this.$bvModal.hide('modal_send_email')
    },
    async findUser(){
      if(this.user_token !== ""){
        const {data} = await axios.get(`${process.env.VUE_APP_URL_TRACKING_PROD}auth/export-information-by-user-id?id=${this.user_token}`)
        if(data){
          this.user_found = data
        }
      }
    },
    async importUser(){
      if(this.user_found && this.user_found.user){
        const obj = {
          name: this.user_found.user.name,
          email: this.user_found.user.email,
          identification: this.user_found.user.identification,
          country: this.user_found.user.country,
          phone: this.user_found.user.phone,
          isActive: true,
          type: 'client',
          isAutoRegister: false,
        }
        const {data} = await post("users/import-user-external-platform", { user: obj,
          transactions: this.user_found.transactions
        }, true)
        if(data){
          this.showMessage("Usuario creado correctamente", "success")
          this.clearUserImport()
        }else{
          this.showMessage("El usuario ya se encuentra registrado. <br> No se importó la informacion", "error")
          this.clearUserImport()
        }
      }else{
        this.showMessage("Por favor busque un usuario", "error")
      }
    },
    clearUserImport(){
      this.user_found = null;
      this.user_token = "";
    }
  }
}
</script>

<style scoped>

</style>
